if (!customElements.get('digital-content-consent')) {
  class DigitalContentConsent extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.error = this.querySelector('[data-consent-error]');
      this.cartForm = document.getElementById('cart');

      if (!this.checkbox || !this.cartForm) return;

      this.onChange = this.handleChange.bind(this);
      this.onInvalid = this.handleInvalid.bind(this);
      this.onSubmit = this.handleSubmit.bind(this);

      this.checkbox.addEventListener('change', this.onChange);
      this.checkbox.addEventListener('invalid', this.onInvalid);
      this.cartForm.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      if (this.checkbox && this.onChange) {
        this.checkbox.removeEventListener('change', this.onChange);
      }

      if (this.checkbox && this.onInvalid) {
        this.checkbox.removeEventListener('invalid', this.onInvalid);
      }

      if (this.cartForm && this.onSubmit) {
        this.cartForm.removeEventListener('submit', this.onSubmit);
      }
    }

    handleChange() {
      if (this.checkbox.checked) {
        this.classList.remove('healvia-digital-consent--invalid');
        if (this.error) this.error.hidden = true;
      }
    }

    handleInvalid(event) {
      event.preventDefault();
      this.showError();
    }

    handleSubmit(event) {
      const isCheckoutSubmission = !event.submitter || event.submitter.name === 'checkout';
      if (!isCheckoutSubmission || this.checkbox.checked) return;

      event.preventDefault();
      this.showError();
    }

    showError() {
      this.classList.add('healvia-digital-consent--invalid');
      if (this.error) this.error.hidden = false;
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.checkbox.focus({ preventScroll: true });
    }
  }

  customElements.define('digital-content-consent', DigitalContentConsent);
}
